import { Box, SubmitButton } from '@/components';
import { useCommentStackSiderView } from '@/features/comment/hooks/stack-sider-view';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';
import { COMMENT_FORM_ID } from './CommentForm';

export const CommentFormHeader: FC = () => {
  const { t } = useTranslation();

  const {
    formState: { isDirty, isSubmitting },
  } = useFormContext();

  const stackSiderView = useCommentStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(siderConfig?.viewType === 'comment-form', t('unreachable-code'));

  return (
    <Box>
      <SubmitButton
        form={COMMENT_FORM_ID}
        disabled={!isDirty && !siderConfig.formValues?.uploadedFilesChanged}
        loading={isSubmitting}
      />
    </Box>
  );
};
